import { DOCUMENT } from "@angular/common";
import { Component, OnInit, Inject } from "@angular/core";
import { HomepageService } from "../../services/homepage.service";
import { SearchService } from "../../services/search.service";
import { AuthService } from "../../services/auth.service";
import { Router, ActivatedRoute, Params } from "@angular/router";
import { Location } from "@angular/common";
import { CookieService } from "ngx-cookie-service";
import { NotifierService } from "angular-notifier";
@Component({
  selector: "app-headerinner",
  templateUrl: "./headerinner.component.html",
  styleUrls: ["./headerinner.component.css"],
})
export class HeaderinnerComponent implements OnInit {
  private readonly notifier: NotifierService;
  gloalSetting: any = [];
  isLogin: any;
  profileDetail: any = [];
  showProfileMenu: boolean = false;
  totalIds: any = 0;
  recentSearch: string = "";
  recentSearchCount: any = "0";
  showMyListop: boolean = false;
  searchSetting: any = [];
  fileToUpload: File = null;
  publishToList: any = [];
  publishToOptionShow: boolean = false;
  patronId: any;
  patronName: any;
  curentLoc: any = [];
  publishResourceName: any = "";
  publishResourceConfirure: any = null;
  publishResourceDescription: any = "";
  publishResourceImage: any = "";
  publishResourceStatus: boolean = false;
  publishToListlist: any;
  totalLocations: any;
  publishDescriptionStatus: boolean = true;
  PulishFormReady: boolean = false;
  isUserLogin: boolean = false;
  facets: any = [];
  sortWith: any;
  currentRoute: string = "";
  showDeleteConfirm: boolean = false;
  data: any;
  libraryCard: any = [];
  dateFormat: string = "M/d/yyyy";
  colors: string;
  imageName: string;

  constructor(
    @Inject(DOCUMENT) private document: Document,
    private location: Location,
    private homepageService: HomepageService,
    private authService: AuthService,
    private router: Router,
    private cookieService: CookieService,
    private activatedRoute: ActivatedRoute,
    private searchService: SearchService,
    notifierService: NotifierService
  ) {
    this.notifier = notifierService;
    this.router.events.subscribe((val) => {
      this.recentSearchCount = this.cookieService.get("recentSearchCunt");
      /* if(localStorage.getItem('selectedResourcesIds') == null || JSON.parse(localStorage.getItem('selectedResourcesIds')).length <= 0){
       $('#myCollectionLi').removeClass('show').addClass('hide');
      } else {
        $('#myCollectionLi').removeClass('hide').addClass('show');
      }*/
    });
    this.homepageService.isLogin$.subscribe((resultList) => {
      this.isLogin = resultList;
      this.checkPatron();
      this.init();
     
    });
    this.authService.logoutObservable$.subscribe((loggedOut) => {
      if (loggedOut) {
        this.logout();
      }
    });
   
  }
  ngDoCheck(){
    if(this.router.url.includes('/list/my')){
      $('#AddAllMyList').addClass('hide').removeClass('show');   
      $("#viewMyList").removeClass("show").addClass("hide");
   }
  }

  init(){
    if (localStorage.getItem('info')){
      this.isLogin = true;
      //this.profileDetail = JSON.parse(this.cookieService.get( 'info'));
      this.profileDetail = JSON.parse(localStorage.getItem('info'));
      if(this.profileDetail.detail.permission.opacAdmin){
            this.document.body.classList.add('login-patron');            
       }
    } else {
      this.profileDetail.detail = [];
    }
    if( this.cookieService.check( 'MyLIstCount')){
      this.totalIds = this.cookieService.get( 'MyLIstCount');
    }
    this.gloalSetting =   this.homepageService.getUpdatedConfig();
    this.recentSearchCount = this.cookieService.get( 'recentSearchCunt');  
  }
 
  ngOnInit() {
  //if(this.cookieService.check( 'info')){
    var checks = this.authService.checkLogin();
    /*if(typeof(checks) != 'undefined'){
      this.isLogin = true;
      this.profileDetail = this.authService.getProfileDetailInfo();
    } else {
      this.isLogin = false;
    }*/
    this.checkPatron();
    this.init();
    this.activatedRoute.queryParams.subscribe(params => {
      if(typeof(params.facets) != 'undefined'  && params.facets != ''){
        var tempFactes = params.facets.split(",");
        for(var i=0; i < tempFactes.length; i++){
          var index = this.facets.indexOf(parseInt(tempFactes[i]));
          if(index < 0){
            this.facets.push(parseInt(tempFactes[i]));
          }
        }
      }
      if(typeof(params.order) != 'undefined'  && params.order != ''){
        this.sortWith = params.order;
      }
    });
  }

  checkPatron(){
    if( this.cookieService.check( 'patron')){
      this.isUserLogin = true;
    } else {
      this.isUserLogin = false;
    }
  }

  changeLocation(location){
    this.searchSetting = this.homepageService.getUpdatedConfig();
    var key = 'selectedlocation'+this.searchSetting.data.tenantCode.toLowerCase();
    this.cookieService.set( key,location);
 	  this.homepageService.setLocationId(location);
    this.homepageService.updateLocation_(location);
    var pagePath = window.location.href;
    if (pagePath.indexOf("/searchlist") == -1) {
      sessionStorage.setItem("lastSearchLocation", location);
    }
  }

  showProfileMenuFn() {
    if ($("#profileLi").hasClass("open")) {
      $("#profileLi").removeClass("open");
      this.showProfileMenu = false;
    } else {
      $("#profileLi").addClass("open");
      $("#myCollectionLi")
        .find(".dropdown-info.myList")
        .removeClass("show")
        .addClass("hide");
      this.showProfileMenu = true;
    }
  }

  logout() {
    this.cookieService.deleteAll("/");
    $("li#loginLi").addClass("show").removeClass("hide");
    $("li#profileLi").removeClass("show").addClass("hide");
    $("li#myCollectionLi").removeClass("show").addClass("hide");
    localStorage.removeItem("info");
    this.document.body.classList.remove("login-patron");
    localStorage.removeItem("selectedResourcesIds");
    localStorage.removeItem("selectedResourcesIds");
    localStorage.removeItem("Session-Id");
    localStorage.removeItem("token");
    window.location.href = "/";
  }

  showMyListOptions(event) {
    if ($("#myCollectionLi").find(".dropdown-info.myList").hasClass("show")) {
      $("#myCollectionLi")
        .find(".dropdown-info.myList")
        .removeClass("show")
        .addClass("hide");
    } else {
      //console.log('profile close');
      $("#profileLi").removeClass("open");
      $("#myCollectionLi")
        .find(".dropdown-info.myList")
        .addClass("show")
        .removeClass("hide");
    }
  }

  showDeleteConfirmation() {
    this.showDeleteConfirm = true;
  }

  hideDeleteConfirmation() {
    this.showDeleteConfirm = false;
  }

  emptyList(event) {
    this.showDeleteConfirm = false;
    if (this.cookieService.check("tempPersonalCollection")) {
      var cacheKey = this.cookieService.get("tempPersonalCollection");
    } else {
      var cacheKey = "";
    }
    this.cookieService.delete("tempPersonalCollection");
    this.cookieService.delete("MyLIstCount");
    $(".onViewList").removeClass("show").addClass("hide");
    $('#Publish-My-List').removeClass('show').addClass('hide');
    this.showMyListop = false;
    //if(this.cookieService.check( 'info')){
    if (localStorage.getItem("info")) {
      var token = localStorage.getItem("token");
      this.homepageService.clearListLogin(token).subscribe((data) => {
        if (data.status) {
          localStorage.removeItem("selectedResourcesIds");
          $("#myCollectionLi").find("span.count").text("0");
          $(".book-box-bottom").each(function () {
            $(this).find(".btn-dander").removeClass("show").addClass("hide");
            $(this)
              .find(".btn-dander")
              .prev(".btn.btn-primary")
              .removeClass("hide")
              .addClass("show");
          });
          $(".book-box-bottom-btn").each(function () {
            $(this).find(".btn-dander").removeClass("show").addClass("hide");
            $(this)
              .find(".btn-dander")
              .prev(".btn.btn-primary")
              .removeClass("hide")
              .addClass("show");
          });
          if (window.location.pathname == "/list/my") {
            this.router.navigate(["/"]);
          }
        }
      });
    } else {
      this.homepageService.clearListTemp(cacheKey).subscribe((data) => {
        localStorage.removeItem("selectedResourcesIds");
        $("#myCollectionLi").find("span.count").text("0");
        $(".book-box-bottom").each(function () {
          $(this).find(".btn-dander").removeClass("show").addClass("hide");
          $(this)
            .find(".btn-dander")
            .prev(".btn.btn-primary")
            .removeClass("hide")
            .addClass("show");
        });
        $(".book-box-bottom-btn").each(function () {
          $(this).find(".btn-dander").removeClass("show").addClass("hide");
          $(this)
            .find(".btn-dander")
            .prev(".btn.btn-primary")
            .removeClass("hide")
            .addClass("show");
        });
        $(".book-box-bottom")
          .find(".btn-dander")
          .removeClass("show")
          .addClass("hide");
        if (window.location.pathname == "/list/my") {
          this.router.navigate(["/"]);
        }
      });
    }
  }

  addAllMyList() {
    var allItems = [];
    var pagePath = window.location.href;
    if (pagePath.indexOf("/new") > -1) {
      this.currentRoute = "new";
    } else if (pagePath.indexOf("/popular") > -1) {
      this.currentRoute = "popular";
    } else {
      this.currentRoute = "";
    }
    if (this.currentRoute == "new") {
      this.homepageService
        .getNewInLibararyPage("date", "true", 10000, this.facets.join())
        .subscribe(
          (data: any) => {
            data.data.resources.forEach((res) => {
              allItems.push(parseInt(res.resourceId));
            });
            if (this.cookieService.check("tempPersonalCollection")) {
              var cacheKey = this.cookieService.get("tempPersonalCollection");
            } else {
              var cacheKey = "";
            }
            this.homepageService
              .personalcollection(allItems, cacheKey)
              .subscribe((data) => {
                if (data.status) {
                  if (localStorage.getItem("selectedResourcesIds") != null) {
                    var storedIds: any = JSON.parse(
                      localStorage.getItem("selectedResourcesIds")
                    );
                    storedIds.forEach((id) => {
                      if (allItems.indexOf(id) < 0) {
                        allItems.push(parseInt(id));
                      }
                    });
                  }
                  var currentList = 0;
                  $(".onViewList").removeClass("hide").addClass("show");
                  $('#Publish-My-List').removeClass('hide').addClass('show');
                  $("#myCollectionLi").find("span.count").text(allItems.length);
                  this.cookieService.set(
                    "MyLIstCount",
                    JSON.stringify(allItems.length)
                  );
                  localStorage.setItem(
                    "selectedResourcesIds",
                    JSON.stringify(allItems)
                  );
                  //if (!this.cookieService.check('info')) {
                  this.removeAddToList(data);
                }
              });
          },
          (error) => {}
        );
    } else if (this.currentRoute == "popular") {
      this.homepageService
        .getPopularPage("date", "true", 10000, this.facets.join())
        .subscribe(
          (data: any) => {
            data.data.resources.forEach((res) => {
              allItems.push(parseInt(res.resourceId));
            });
            if (this.cookieService.check("tempPersonalCollection")) {
              var cacheKey = this.cookieService.get("tempPersonalCollection");
            } else {
              var cacheKey = "";
            }
            this.homepageService
              .personalcollection(allItems, cacheKey)
              .subscribe((data) => {
                if (data.status) {
                  if (localStorage.getItem("selectedResourcesIds") != null) {
                    var storedIds: any = JSON.parse(
                      localStorage.getItem("selectedResourcesIds")
                    );
                    storedIds.forEach((id) => {
                      if (allItems.indexOf(id) < 0) {
                        allItems.push(parseInt(id));
                      }
                    });
                  }
                  var currentList = 0;
                  $(".onViewList").removeClass("hide").addClass("show");
                  $('#Publish-My-List').removeClass('hide').addClass('show');
                  $("#myCollectionLi").find("span.count").text(allItems.length);
                  this.cookieService.set(
                    "MyLIstCount",
                    JSON.stringify(allItems.length)
                  );
                  localStorage.setItem(
                    "selectedResourcesIds",
                    JSON.stringify(allItems)
                  );
                  // (!this.cookieService.check('info')) {
                  this.removeAddToList(data);
                }
              });
          },
          (error) => {}
        );
    } else {
      $(".addButtonList").each(function () {
        var itemId = parseInt($(this).attr("resourceId"));
        allItems.push(itemId);
        $(".addButton" + itemId)
          .addClass("hide")
          .removeClass("show")
          .removeClass("fadeOutUp");
        $(".removeButton" + itemId)
          .addClass("show")
          .removeClass("hide");
      });
      if (this.cookieService.check("tempPersonalCollection")) {
        var cacheKey = this.cookieService.get("tempPersonalCollection");
      } else {
        var cacheKey = "";
      }
      this.homepageService
        .personalcollection(allItems, cacheKey)
        .subscribe((data) => {
          if (data.status) {
            if (localStorage.getItem("selectedResourcesIds") != null) {
              var storedIds: any = JSON.parse(
                localStorage.getItem("selectedResourcesIds")
              );
              storedIds.forEach((id) => {
                if (allItems.indexOf(id) < 0) {
                  allItems.push(parseInt(id));
                }
              });
            }
            var currentList = 0;
            $(".onViewList").removeClass("hide").addClass("show");
            $('#Publish-My-List').removeClass('hide').addClass('show');
            $("#myCollectionLi").find("span.count").text(allItems.length);
            this.cookieService.set(
              "MyLIstCount",
              JSON.stringify(allItems.length)
            );
            localStorage.setItem(
              "selectedResourcesIds",
              JSON.stringify(allItems)
            );
            //if (!this.cookieService.check('info')) {
            this.removeAddToList(data);
          }
        });
    }
  }

  removeAddToList(data: any) {
    if (localStorage.getItem("info") != null) {
      if (data.data && data.data.cacheKey) {
        this.cookieService.set(
          "tempPersonalCollection",
          data.data.cacheKey,
          365,
          "/"
        );
      }
    }
    $(".book-box-bottom").each(function () {
      $(this).find(".btn-primary").removeClass("show").addClass("hide");
      $(this)
        .find(".btn-primary")
        .prev(".btn.btn-dander")
        .removeClass("hide")
        .addClass("show");
    });
    $(".book-box-bottom-btn").each(function () {
      $(this).find(".btn-primary").removeClass("show").addClass("hide");
      $(this)
        .find(".btn-primary")
        .prev(".btn.btn-dander")
        .removeClass("hide")
        .addClass("show");
    });
    $(".book-box-bottom")
      .find(".btn-dander")
      .removeClass("hide")
      .addClass("show");
  }

  getPublishedReadingLists() {
    this.PulishFormReady = false;
    this.publishResourceStatus = false;
    this.publishToOptionShow = false;
    this.publishDescriptionStatus = true;
    this.publishResourceName = "";
    this.publishResourceConfirure = null;
    this.publishResourceDescription = "";
    this.publishResourceImage = "";
    //if(this.cookieService.check( 'info')){
    if (localStorage.getItem("info")) {
      var token = localStorage.getItem("token");
      //var detail = JSON.parse(this.cookieService.get( 'info')).detail;
      var detail = JSON.parse(localStorage.getItem("info")).detail;
      this.patronId = detail.patronId;
      this.patronName = detail.firstName + " " + detail.lastName;
    }
    this.homepageService.getPublishedReadingLists(token).subscribe((list) => {
      this.publishToListlist = list.data;
    });
    this.homepageService.getConfig().subscribe((data) => {
      this.PulishFormReady = true;
      var tenant = data.data.tenantCode.toLowerCase();
      var selectedId = this.cookieService.get("selectedlocation" + tenant);
      this.totalLocations = data.data.settings.location.locations.length;
      data.data.settings.location.locations.forEach((loc) => {
        if (loc.id == selectedId) {
          this.curentLoc["id"] = loc.id;
          this.curentLoc["name"] = loc.name;
        }
      });
      $("#publishToChange").trigger("change");
    });
  }

  publishToChange(option) {
    this.publishResourceStatus = true;
    if (option != "") {
      this.publishToOptionShow = true;
      //if(this.cookieService.check( 'info')){
      if (localStorage.getItem("info")) {
        var token = localStorage.getItem("token");
      }
      this.homepageService
        .getReadingListsDetail(option, token)
        .subscribe((detail: any) => {
          this.publishResourceName = detail.data.name;
          this.publishResourceConfirure = detail.data.configurationId;
          this.publishResourceDescription = detail.data.description;
          this.publishResourceImage = detail.data.imageUrl;
          this.publishResourceStatus = false;
        });
    } else {
      this.publishToOptionShow = false;
      this.publishResourceName = "";
      this.publishResourceConfirure = null;
      this.publishResourceDescription = "";
      this.publishResourceImage = "";
      this.publishResourceStatus = false;
    }
    var listType = $("#publishToChange option:selected").attr("listType");
    if (listType == "P" || listType == "N") {
      this.publishDescriptionStatus = false;
    } else {
      this.publishDescriptionStatus = true;
    }
  }

  savePublishToList() {
    var error: number = 0;
    var listType = $("#publishToChange option:selected").attr("listType");
    var existingCollectionId = $("#publishToChange").val();
    var operation = $('input[name="add_to"]:checked').val();
    var resourceIds = JSON.parse(localStorage.getItem("selectedResourcesIds"));
    var name = $.trim($("#publishResourceName").val().toString());
    if (name == "" && listType != "N" && listType != "P") {
      $("#publishResourceName").addClass("error");
      $("#publishResourceName").after(
        '<small class="error">Title is required.</small>'
      );
      error++;
    }
    var imageUrl = $("#publishResourceImage").val();
    var locationId = $('input[name="PublishselectLocation"]:checked').val();
    var description = $.trim($("#publishResourceDescription").val().toString());

    if (description == "" && listType != "N" && listType != "P") {
      $("#publishResourceDescription").addClass("error");
      $("#publishResourceDescription").after(
        '<small class="error">Description is required.</small>'
      );
      error++;
    }
    //if(this.cookieService.check( 'info')){
    if (localStorage.getItem("info")) {
      var auth = localStorage.getItem("token");
    }
    if (error > 0) {
      $(".submit-btn").attr("disabled", "disabled");
      setTimeout(function () {
        $("#Publish-My-List-Modal").find("small.error").remove();
        $("#Publish-My-List-Modal").find(".error").removeClass("error");
        $(".submit-btn").removeAttr("disabled");
      }, 3000);
      return false;
    }
    this.publishResourceStatus = true;
    if (listType == "R") {
      this.homepageService
        .publishToreadingList(
          existingCollectionId,
          operation,
          resourceIds,
          name,
          description,
          imageUrl,
          locationId,
          auth
        )
        .subscribe((data: any) => {
          if (data.status) {
            this.notifier.notify("success", data.message);
            $("#PublishMyListModalClose").trigger("click");
            this.router.navigate(["/"]);
          }
          this.publishResourceStatus = false;
        });
    } else if (listType == "N" || listType == "P") {
      this.homepageService
        .publishToNewInLibrary(
          existingCollectionId,
          operation,
          resourceIds,
          name,
          auth
        )
        .subscribe((data: any) => {
          if (data.status) {
            this.notifier.notify("success", data.message);
            $("#PublishMyListModalClose").trigger("click");
            this.router.navigate(["/"]);
          }
          this.publishResourceStatus = false;
        });
    } else if (listType == "A") {
      this.homepageService
        .publishToNewList(
          resourceIds,
          name,
          description,
          imageUrl,
          locationId,
          auth
        )
        .subscribe((data: any) => {
          if (data.status) {
            this.notifier.notify("success", data.message);
            $("#PublishMyListModalClose").trigger("click");
            this.router.navigate(["/"]);
          }
          this.publishResourceStatus = false;
        });
    }
  }

  uploadImagePublish(files: FileList) {
    this.publishResourceStatus = true;
    this.fileToUpload = files.item(0);
    let formData = new FormData();
    formData.append("file", this.fileToUpload, this.fileToUpload.name);
    //if(this.cookieService.check( 'info')){
    if (localStorage.getItem("info")) {
      var token = localStorage.getItem("token");
    }
    this.homepageService
      .readingListImageUpload(formData, token)
      .subscribe((data: any) => {
        this.publishResourceStatus = false;
        $("#publishResourceImage").attr("value", data.data.url);
        $("#publishResourceImage").parent().addClass("haveImage");
        $("#publishResourceImage")
          .parent()
          .find("img.regularImage")
          .removeClass("hide")
          .removeClass("show")
          .attr("src", data.data.url);
      });
  }
  getLibraryCardDetail() {
    this.homepageService.getLibraryCard().subscribe(
      (data: any) => {
        this.libraryCard = data.data;
        this.dateFormat = this.homepageService.formatDate();
        this.colors = this.homepageService.bgColor(data.data.number);
        this.patronName = data.data.firstName + " " + data.data.lastName;
        this.imageName = this.homepageService.initialName(this.patronName);
        return this.libraryCard;
      },
      (error) => {
        this.notifier.notify("error", "Something went wrong.");
      }
    );
  }
}
